<template>
    <div
        v-if="!loading"
        class="flex flex-col min-h-screen"
    >
        <navigation
            v-if="navigation"
            :doc="navigation"
        />
        <site-header
            v-if="header"
            :doc="header"
        />

        <main>
            <page-section
                v-for="(id, index) in doc.sections"
                :key="index"
                :index="index"
                :id="id"
            />
        </main>

        <site-footer
            v-if="footer"
            :doc="footer"
        />
    </div>
</template>

<script>
import site from "@/mixins/site";

import PageSection from "@/components/PageSection";

export default {
    name: "page",

    mixins: [site],

    components: {
        PageSection
    },

    mounted() {
        console.log(this);
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/Page.vue